export class HeaderController {
  constructor() {}
}
